import React from "react";
import { func } from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import brandTheme from "brandTheme/Theme";

const useStyles = makeStyles((theme) => ({
  popperNav: {
    zIndex: 1300,

    [theme.breakpoints.down("sm")]: {
      zIndex: 1300,
      minWidth: 180,
    },
  },

  paper: {
    minWidth: 180,
    marginTop: theme.spacing(1),
    borderRadius: 6,
  },

  dropdownItem: {
    backgroundColor: brandTheme.white,
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
}));

const DropDown = ({
  handleCloseProfile,
  navigateToLoginPage,
  openProfile,
  handleExitToSSO,
}) => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const { authToken } = useSelector((state) => state.login.authData);

  const handlelogout = async () => {
    try {
      await apiHandler({
        url: endpoint.LOGOUT,
        authToken,
      });

      dispatch({ type: "SIGNOUT" });
      sessionStorage.removeItem("session");

      navigateToLoginPage();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Popper
      open={Boolean(openProfile)}
      anchorEl={openProfile}
      placement="bottom-end"
      transition
      className={classes.popperNav}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps}>
          <Paper elevation={4} className={classes.paper}>
            <ClickAwayListener onClickAway={handleCloseProfile}>
              <MenuList autoFocusItem={Boolean(openProfile)}>
                <MenuItem
                  className={classes.dropdownItem}
                  onClick={() => {
                    handleCloseProfile();
                    handlelogout();
                  }}
                >
                  Logout
                </MenuItem>

                {/* <MenuItem
                  className={classes.dropdownItem}
                  onClick={() => {
                    handleCloseProfile();
                    handleExitToSSO();
                  }}
                >
                  Exit to SSO
                </MenuItem> */}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

DropDown.propTypes = {
  handleCloseProfile: func,
  navigateToLoginPage: func,
  openProfile: func,
  handleExitToSSO: func,
};

export default DropDown;